import { SyncTaskUIStatus } from '@/renderer/scripts/CoSync/SyncCenter/SyncCenter';

/**
 *
 *
 * @export
 * @class SyncCenterDataRelay
 * // SyncCenter的数据中继
 * 由于延迟加载逻辑的存在，这里需要有一层数据中继，确保在延迟初始化的场景下，未初始化好就获取数据不会触发创建Center
 * 这里存放Center中的public数据
 */
export class SyncCenterDataRelay {
  public syncTaskStatusMap?: Map<number, SyncTaskUIStatus> = undefined;

  public setupEmptySyncTaskStatusMap() {
    if (!this.syncTaskStatusMap) {
      this.syncTaskStatusMap = new Map<number, SyncTaskUIStatus>();
    }
  }

  public setSyncTaskStatusMap(localSyncId: number, status: SyncTaskUIStatus) {
    if (!this.syncTaskStatusMap) {
      this.syncTaskStatusMap = new Map<number, SyncTaskUIStatus>();
    }
    this.syncTaskStatusMap.set(localSyncId, status);
  }

  public deleteSyncTaskStatusMap(localSyncId: number) {
    if (!this.syncTaskStatusMap) {
      this.syncTaskStatusMap = new Map<number, SyncTaskUIStatus>();
    }
    this.syncTaskStatusMap.delete(localSyncId);
  }

  public reset() {
    this.syncTaskStatusMap?.clear();
    this.syncTaskStatusMap = undefined;
  }
}
